import React, { useMemo } from 'react'
import { FilterName, FilterParam } from '../FilterBar.types'
import { DocumentationFilterValues } from '../FilterBar.constants'
import { FilterDropdown } from './FilterDropdown'

export const HasDocumentationFilterDropdown = React.memo(
  ({
    param,
    name,
    isNested = false,
  }: {
    param: FilterParam.HAS_DOCUMENTATION | FilterParam.IS_CUSTOMIZED
    name: FilterName.HAS_DOCUMENTATION | FilterName.IS_CUSTOMIZED
    isNested?: boolean
  }): JSX.Element => {
    const filterValues = useMemo(
      () => [
        {
          value: DocumentationFilterValues.TRUE,
          label: 'True',
        },
        {
          value: DocumentationFilterValues.FALSE,
          label: 'False',
        },
      ],
      [],
    )

    return (
      <FilterDropdown
        filterParam={param}
        filterName={name}
        filterValues={filterValues}
        isNested={isNested}
      />
    )
  },
)
